<template>
  <div :class="headerClasses">
    <h2 v-if="title" :class="titleClasses">
      {{ title }}
    </h2>
    <p v-if="subtitle" :class="subtitleClasses">
      {{ subtitle }}
    </p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    align: {
      type: String,
      default: 'center',
      validator: (value) => ['left', 'center', 'right'].includes(value)
    },
    gradient: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'large', 'small'].includes(value)
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    headerClasses() {
      return [
        'section-header',
        `section-header--${this.align}`,
        { 'section-header--dark': this.dark }
      ]
    },
    titleClasses() {
      return [
        'section-header__title',
        `section-header__title--${this.variant}`,
        { 'section-header__title--gradient': this.gradient }
      ]
    },
    subtitleClasses() {
      return [
        'section-header__subtitle',
        `section-header__subtitle--${this.variant}`
      ]
    }
  }
}
</script>

<style scoped>
/* Header Container */
.section-header {
  margin-bottom: 60px;
}

.section-header--left {
  text-align: left;
}

.section-header--center {
  text-align: center;
}

.section-header--right {
  text-align: right;
}

/* Title Styles */
.section-header__title {
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 20px 0;
  color: #1a1a1a;
}

.section-header--dark .section-header__title {
  color: #ffffff;
}

/* Title Variants */
.section-header__title--small {
  font-size: 32px;
}

.section-header__title--default {
  font-size: 48px;
}

.section-header__title--large {
  font-size: 64px;
}

/* Gradient Title */
.section-header__title--gradient {
  background: linear-gradient(90deg, #00F5FF 0%, #FF00FF 50%, #00F5FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Subtitle Styles */
.section-header__subtitle {
  margin: 0;
  line-height: 1.6;
  color: #666666;
}

.section-header--dark .section-header__subtitle {
  color: rgba(255, 255, 255, 0.9);
}

.section-header__subtitle--small {
  font-size: 14px;
}

.section-header__subtitle--default {
  font-size: 16px;
}

.section-header__subtitle--large {
  font-size: 20px;
}

/* Responsive Design */
@media (max-width: 960px) {
  .section-header {
    margin-bottom: 45px;
  }

  .section-header__title--small {
    font-size: 26px;
  }

  .section-header__title--default {
    font-size: 34px;
  }

  .section-header__title--large {
    font-size: 46px;
  }

  .section-header__subtitle--default {
    font-size: 15px;
  }

  .section-header__subtitle--large {
    font-size: 18px;
  }
}

@media (max-width: 600px) {
  .section-header {
    margin-bottom: 35px;
    padding: 0 10px;
  }

  .section-header__title {
    line-height: 1.3;
  }

  .section-header__title--small {
    font-size: 22px;
  }

  .section-header__title--default {
    font-size: 26px;
  }

  .section-header__title--large {
    font-size: 32px;
  }

  .section-header__subtitle--small {
    font-size: 12px;
  }

  .section-header__subtitle--default {
    font-size: 13px;
  }

  .section-header__subtitle--large {
    font-size: 15px;
  }
}

@media (max-width: 400px) {
  .section-header {
    margin-bottom: 30px;
  }

  .section-header__title--small {
    font-size: 20px;
  }

  .section-header__title--default {
    font-size: 24px;
  }

  .section-header__title--large {
    font-size: 28px;
  }
}
</style>
